import { PageDataHandler } from "@/lib/utility/data/page-data-handler";
import { PageFilterOperationEnum } from "@/lib/utility/data/page-filter-operation.enum";
import { $t } from "@/lib/utility/t";
import { IPageFilterElement, PageFilterElement } from "@/models/page-filter-element.entity";
import { IProduct, Product } from "@/models/product.entity";
import { MrfiktivProductControllerGetParamsGen } from "@/services/mrfiktiv/v1/data-contracts";
import store from "@/store/VuexPlugin";
import { PredefinedFilterType } from "@/views/event/filter/event.filter";
import { getModule, Module } from "vuex-module-decorators";
import { PaginatedBaseStore } from "../paginated-base.store";
import { ProductDataAccessLayer } from "./access-layers/product.access-layer";
import { PaginationFilterListElement } from "./base-pagination.store";
import { ProductPageDataProvider } from "./page-data-provider/product.page-data-provider";

@Module({
  dynamic: true,
  namespaced: true,
  name: "product",
  store
})
export class ProductStore extends PaginatedBaseStore<IProduct, MrfiktivProductControllerGetParamsGen> {
  protected _data = ProductDataAccessLayer;
  protected _pageProvider = ProductPageDataProvider;
  protected _pager = new PageDataHandler(this._data, this._pageProvider);

  get predefinedFilter(): PredefinedFilterType[] {
    return [
      {
        name: $t("objects.product.isActive"),
        filter: [
          new PageFilterElement({
            key: "isActive",
            operation: PageFilterOperationEnum.EQUAL,
            value: true as any
          })
        ]
      }
    ];
  }

  filterOptions: PaginationFilterListElement[] = Product.filterables;

  hiddenFilter: IPageFilterElement[] = [];
}

export const ProductModule = getModule(ProductStore);
